import InvestmentDepositForm from './InvestmentDepositForm';

export default InvestmentDepositForm;
